import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import { Box, Grid, Icon } from "@mui/material";
import {
  FETCH_DOC_ITEMS_ERROR,
  FETCH_DOC_ITEMS_SUCCESS,
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useLocation, useNavigate } from "react-router";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import { setBillReducer } from "../../store/actions/billActions";
import CoreDataTableDashboard from "../../core/dataDisplay/datatable/CoreDataTableDashboard";

export default function InvoiceDashboard() {
  const users = useSelector((state) => state.bill.userDocs);
  const invoiceItems = useSelector((state) => state.bill.invoiceItems);
  const user = useSelector((state) => state.auth.user);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const location = useLocation();
  const tools = useSelector((state) => state.common.tools);

  const tool = location.pathname.split("/")[1];
  const toolMeta = tools?.find((t) => t.name === tool)?.extraInfo?.dashboard;

  const [open, setModal] = useState(false);
  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setModal(false);
    getData();
    dispatch(
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
    );
  }, []);

  useEffect(() => {
    if (users && users.length) {
      let cols = users[0] ? Object.keys(users[0]?.info?.criteria) : [];
      cols = cols?.map((col) => {
        return { name: col, isBoolean: typeof users[0][col] === Boolean };
      });

      setColumns(cols);
    }
  }, [users]);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
    if (groupDocsError) {
      alert("Internal error");
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
  }, [groupDocsSuccess, groupDocsError]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ userId: user.id, tool, type: "basic" }),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/ItemGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ userId: user.id, tool, type: "items" }),
          ),
        },
        null,
        FETCH_DOC_ITEMS_SUCCESS,
        FETCH_DOC_ITEMS_ERROR,
        true,
        false,
      ),
    );
  };

  const viewDocs = (row) => {
    navigate("/" + tool + "/docs/view", {
      state: { docGroupId: row.id, label: row.fieldValue },
    });
  };
  const viewItemDocs = (row) => {
    navigate("/" + tool + "/docs/view", {
      state: { itemGroupId: row.id, label: row.fieldValue },
    });
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  return (
    <Box style={{ width: "100%" }}>
      <Grid container>
        <Grid xs={12} sm={6}>
          <Box style={{ padding: 16 }}>
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <CoreH6>{toolMeta?.headline || "Document Users"}</CoreH6>
              <CoreIconButton onClick={groupData}>
                <Icon>sync</Icon>
              </CoreIconButton>
            </Box>
            {columns && columns?.length > 0 && (
              <CoreDataTableDashboard
                showToolbar={false}
                selectable={false}
                noOfRows={10}
                rowActions={[
                  { title: "View", icon: "chevron_right", onClick: viewDocs },
                ]}
                columns={[
                  {
                    view: (row) => {
                      return row.fieldValue
                        ? row.fieldValue[0].toUpperCase() +
                            row.fieldValue.slice(1)
                        : "";
                    },
                    name: "name",
                    label: toolMeta?.name || "Name",
                    width: "60%",
                  },
                  ...(columns?.map((col) => {
                    return {
                      view: (row) => {
                        if (row.info?.criteria) {
                          if (col.isBoolean) {
                            if (row.info.criteria[col.name]) {
                              return <Icon color="success">check_circle</Icon>;
                            } else {
                              return <Icon color="error">cancel</Icon>;
                            }
                          } else if (row.info?.criteria[col.name]) {
                            try {
                              let x = Number(row.info?.criteria[col.name]);
                              if (isNaN(x)) {
                                return (
                                  row.info?.criteria[
                                    col.name
                                  ][0].toUpperCase() +
                                  row.info?.criteria[col.name].slice(1)
                                );
                              } else {
                                return x.toFixed(2);
                              }
                            } catch (err) {
                              return (
                                row.info?.criteria[col.name][0].toUpperCase() +
                                row.info?.criteria[col.name].slice(1)
                              );
                            }
                          } else return null;
                        }
                      },
                      name: col.name,
                      label: col.name,
                      width: "20%",
                    };
                  }) || []),
                ]}
                rows={users || []}
              />
            )}
          </Box>
        </Grid>
        <Grid xs={12} sm={6}>
          <Box style={{ padding: 16 }}>
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <CoreH6>{toolMeta?.itemHeader || "Items"}</CoreH6>
              <CoreIconButton onClick={groupData}>
                <Icon>sync</Icon>
              </CoreIconButton>
            </Box>
            {columns && columns?.length > 0 && (
              <CoreDataTableDashboard
                showToolbar={false}
                selectable={false}
                noOfRows={10}
                rowActions={[
                  {
                    title: "View",
                    icon: "chevron_right",
                    onClick: viewItemDocs,
                  },
                ]}
                columns={[
                  {
                    view: (row) => {
                      return row.fieldValue
                        ? row.fieldValue[0].toUpperCase() +
                            row.fieldValue.slice(1)
                        : "";
                    },
                    name: "name",
                    label: toolMeta?.itemName || "Item",
                    width: "60%",
                  },
                  {
                    view: (row) => {
                      if (row.info?.criteria) {
                        if (row.info?.criteria["Qty"]) {
                          if (isNaN(Number(row.info?.criteria["Qty"]))) {
                            return row.info?.criteria["Qty"];
                          } else {
                            return Number(row.info?.criteria["Qty"]).toFixed(2);
                          }
                        } else return null;
                      }
                    },
                    isNumeric: true,
                    name: "Quantity",
                    label: "Quantity",
                    width: "20%",
                  },
                ]}
                rows={invoiceItems || []}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
